import BasicModel from "./basic_model";
import Movement from "./movement";

export default class Divider extends Movement {
  render = function () {
    this.setupContext();

    this.context.beginPath();
    this.context.moveTo(this.x(), this.y());

    this.context.lineWidth = 2;
    this.context.strokeStyle = "rgba(80, 200, 125, 1)";
    this.context.stroke();

    this.renderMovement();
    if (this.selected) {
      for (let p in this.modifiers) {
        const modifier = this.modifiers[p];
        const highlighted = p == this.highlightedModifier;
        this.renderModifier(modifier.origin[0] * s, modifier.origin[1] * s, modifier.radius * s, highlighted)
      }
    }

    this.resetContext();
  }

  renderModifier = function(x, y, r, selected) {
    this.context.beginPath();
    this.context.strokeStyle = "rgba(255, 255, 0, 0.6)";
    this.context.lineWidth = 2;
    this.context.arc(x, y, r, 0, 2 * Math.PI, true);
    this.context.stroke();

    if (selected) {
      this.context.beginPath();
      this.context.lineWidth = 1;
      this.context.strokeStyle = "rgba(255, 255, 255, 0.5)";
      this.context.rect(x-r-5, y-r-5, r*2+10, r*2+10);
      this.context.stroke();
    }
  }

  boundingBox = function () {
    return false;
  }
}



